<template>
  <div :class="['row mx-0', addContainerClasses]">
    <div class="col-12 col-md-4 col-xl-3 pb-3 font-weight-bold" v-html="title" />
    <div class="col-12 col-md-8 col-xl-9">
      <button type="button"
        v-for="(item, index) in items"
        :key="index"
        :class="['btn btn-sm btn-outline-filter', filterUiState('impactSoundLevel', item.value)]"
        v-on:click="selectValue(item.value)">{{ item.title }}</button>
    </div>
  </div>
</template>

<script>

import { mapGetters } from 'vuex'
import { trackCallstack } from '../../../helper/tracker'

export default {
  name: 'StoCscFilterSectionImpactSoundLevel',
  props: {
    addContainerClasses: String
  },
  data: function () {
    return {
      title: 'L<sub>n,W</sub> (C<sub>l</sub>;C<sub>l50-2500</sub>)) [dB]',
      items: [
        { title: '≤ 30', value: 30 },
        { title: '≤ 31', value: 31 },
        { title: '≤ 32', value: 32 },
        { title: '≤ 33', value: 33 },
        { title: '≤ 34', value: 34 },
        { title: '≤ 35', value: 35 },
        { title: '≤ 36', value: 36 },
        { title: '≤ 37', value: 37 },
        { title: '≤ 40', value: 40 },
        { title: '≤ 41', value: 41 },
        { title: '≤ 45', value: 45 },
        { title: '≤ 46', value: 46 },
        { title: '≤ 47', value: 47 },
        { title: '≤ 48', value: 48 },
        { title: '≤ 50', value: 50 },
        { title: '≤ 51', value: 51 },
        { title: '≤ 53', value: 53 },
        { title: '≤ 54', value: 54 },
        { title: '≤ 55', value: 55 },
        { title: '≤ 56', value: 56 },
        { title: '≤ 57', value: 57 },
        { title: '≤ 58', value: 58 },
        { title: '≤ 59', value: 59 },
        { title: '≤ 61', value: 61 },
        { title: '≤ 62', value: 62 }
      ]
    }
  },
  computed: {
    ...mapGetters({
      filterUiState: 'filter/uiState',
      filterState: 'filter/state'
    })
  },
  methods: {
    selectValue: function (value) {
      let title = ''
      const result = this.items.filter(item => item.value === value)
      if (result.length > 0) title = result[0].title

      const uiState = this.filterUiState('impactSoundLevel', value)

      this.$gtm.trackEvent({
        event: 'filter',
        category: this.title.split('<sub>').join('').split('</sub>').join('') + ' ' + title,
        action: uiState === 'pending' ? 'hinzufügen' : (uiState === 'active' ? 'reaktivieren' : 'aktivieren'),
        label: title,
        value: value
      })

      this.$store.dispatch('filter/setValue', {
        name: 'impactSoundLevel',
        title: this.title + ' ' + title,
        value: value
      }).then(() => trackCallstack(this.$gtm, this.filterState._callstack))
    }
  }
}

</script>
